<template>
  <div class="speaker">
    <img src="/static/img/icons/delete.svg" class="delete-icon delete-speaker" @click="deleteWebinarSpeakerAndRedirect(speaker.id)"/>
    <div class="rounded-photo-wrapper centered speaker-photo" @click="handleLoadSpeakerPhoto(speaker.id)" v-if="!speaker.photo">
      <span>Сменить фото</span>
    </div>
    <div v-else class="speaker-photo with-background-image" v-bind:style="photoStyle">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteWebinarSpeakerPhoto(speaker.id)"/>
    </div>
    <b-field :class="{'is-danger': errors.has('speaker-name') }">
      <b-input
        placeholder="Имя фамилия"
        v-model="speaker.name"
        @change="updateWebinarSpeaker(speaker)"
        v-validate="'required'"
        name="speaker-name"
      />
    </b-field>
    <b-field>
      <b-input
        type="textarea"
        @change="updateWebinarSpeaker(speaker)"
        placeholder="Должность, какую компанию представляет"
        v-model="speaker.post"
      />
    </b-field>
    <div class="save-content-button centered">
      <button class="button save-content" @click="handleSaveWebinarSpeaker" :disabled="disabled">СОХРАНИТЬ</button>
    </div>
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'WebinarSpeaker',
  data () {
    return {
      disabled: false
    }
  },
  props: ['speaker'],
  computed: {
    photoStyle () {
      return this.speaker.photo
      ? {background: !this.speaker.photo.base64photo ? `url(/upload/photos/${this.speaker.photo})` : `url(${this.speaker.photo.base64photo})`}
      : {background: ''}
    }
  },
  methods: {
    ...mapActions(['updateWebinarSpeaker', 'loadWebinarSpeakerPhoto',
      'deleteWebinarSpeakerPhoto', 'deleteWebinarSpeaker', 'addWebinarSpeakerPhoto', 'saveWebinarSpeaker']),
    handleSaveWebinarSpeaker () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true
          this.saveWebinarSpeaker(this.speaker)
          .then(() => {
            this.disabled = false
            this.$toast.open({ message: 'Сохранено' })
            this.$emit('speaker-saved');
            setTimeout(() => this.$router.push({ name: 'Webinars' }), 1000)
          })
        }
      })
    },
    handleLoadSpeakerPhoto (id) {
      this.$refs.loadPhotoButton.click()
    },
    loadPhoto (e) {
      const reader = new FileReader()
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (e) => {
        this.addWebinarSpeakerPhoto({
          data: formData,
          base64photo: e.target.result,
          speakerId: this.speaker.id
        })
      }
    },
    deleteWebinarSpeakerAndRedirect(speakerId) {
      this.deleteWebinarSpeaker(speakerId).then(() => {
        setTimeout(() => this.$router.push({ name: 'Webinars' }), 1000);
      }).catch((error) => {
        console.error("Ошибка при удалении спикера:", error);
      });
    }
  }
}
</script>
<style scoped>
.speaker {
  position: relative;
}
.rounded-photo-wrapper, .speaker-photo {
  width: 160px;
  height: 160px;
  margin: 5px 0 15px;
  display: inline-flex;
}
.speaker-photo {
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}
.delete-icon {
  top: 0;
}
.delete-speaker {
  top: -5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// WebinarSpeaker.vue?225d7569